import React from "react";
import { Link } from "react-router-dom";
import {
  constants,
  DateFormat,
} from "../../../Containers/Constants/commenFeatures";

const ArticleBanner = ({ img, article }) => {
  return (
    <div className="articleWraps artical_page_wrap no_border">
      <div className="art_banner">
        <img src={img} alt="Article-Banner"></img>
      </div>
      <div>
        <div className="infos ">
          {article.headTitle && <h2>{article.headTitle}</h2>}
          <Link to={article ? `/articles/${article.resourceId}` : ""}>
            {article.name && <h6>{article.name}</h6>}
          </Link>
        </div>
        <div className="display-flex align-center articleWrapsInfo">
          <p className="date">
            {article
              ? DateFormat(article.date, constants.resourceDateFormat)
              : ""}
          </p>
          {/* <p>
            <a className="disabled" href="javascript:void(0)">
              Product
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default ArticleBanner;
